import React, { useState, useEffect } from 'react'
import './styles/Table.css'
import './styles/crearFormulario.scss'
import MaterialTable from 'material-table'
// import GetAppIcon from '@material-ui/icons/GetApp'
// import FileUploadIcon from '@mui/icons-material/FileUpload'
import CheckIcon from '@mui/icons-material/Check'
import ClearIcon from '@mui/icons-material/Clear'
import {
  Grid,
  Box,
  Modal,
  FormControl,
  TextField,
  Button,
} from '@material-ui/core'
import Swal from 'sweetalert2'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'
import { useAuthentication } from '../../../../context/authenticationContext'
import { getMyNotificationIFI } from '../../../../services/Representacion/get'
import { AprobarRechazarRepresentar } from '../../../../services/Representacion/create'

const TableFormularios = () => {
  const { IdIFIToken, userIDB2C } = useAuthentication()
  const [loading, setLoading] = useState(true)
  const [body, setBody] = useState({
    Observation: '',
  })

  useEffect(() => {
    // setLoading(true)
    getNotificaciones()
  }, [])

  const getNotificaciones = async () => {
    try {
      const response = await getMyNotificationIFI(IdIFIToken, 1)
      if (response.Success) {
        if (response.Data.length > 0) {
          setTableForms(response.Data)
        } else {
          setTableForms([])
        }
      }
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
    setLoading(false)
  }

  const columns = [
    {
      title: 'Tipo',
      field: 'NotificationType',
      sorting: true,
      filtering: true,
    },
    {
      title: 'Nombre Mipyme',
      field: 'MiPymeName',
      sorting: true,
      filtering: true,
    },
    {
      title: 'Fecha',
      field: 'CreatedDate',
      sorting: true,
      filtering: true,
      type: 'date',
    },
    {
      title: 'Nombre Usuario MIPYME',
      field: 'UserName',
      sorting: true,
      filtering: true,
    },
    {
      title: 'Correo Electrónico Usuario MIPYME',
      field: 'EMail',
      sorting: true,
      filtering: true,
    },
  ]

  const [TableForms, setTableForms] = useState([])

  const handleClose = () => {
    setOpen(false)
    setBody({
      Observation: '',
    })
  }
  const [open, setOpen] = React.useState(false)
  const handleOpen = () => setOpen(true)

  const handleActualizar = async () => {
    const response = await AprobarRechazarRepresentar(
      IdNotification,
      false,
      body.Observation,
      userIDB2C,
    )
    if (response.Success) {
      Swal.fire({
        title: '¡Solicitud Rechazada Exitosamente!',
        icon: 'success',
      })

      handleClose()
      getNotificaciones()
    } else {
      Swal.fire({
        title:
          'Ocurrio un Error al actualizar el formulario...' + response.Message,
        icon: 'error',
      })
    }
  }

  const AprobarSolicitud = async (idForm) => {
    try {
      const response = await AprobarRechazarRepresentar(
        idForm,
        true,
        null,
        userIDB2C,
      )
      if (response.Success) {
        Swal.fire({
          title: 'Solicitud Aprobada exitosamente!',
          icon: 'success',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Entendido',
        })
        getNotificaciones()
      }
    } catch (error) {
      console.log(error)
    }
  }

  const [IdNotification, setIdNotification] = useState([])

  return (
    <section>
      {!loading ? (
        <Grid
          container
          style={{
            width: '100%',
            height: 'auto',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              height: 'auto',
              width: '96%',
              backgroundColor: '#fff',
              borderRadius: '4px',
            }}
          >
            <div className="App">
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={12}>
                  <MaterialTable
                    columns={columns}
                    data={TableForms}
                    actions={[
                      {
                        icon: () => <CheckIcon color="success" />,
                        tooltip: 'Aprobar',
                        onClick: (event, rowData) => {
                          AprobarSolicitud(rowData.IdNotification)
                        },
                      },
                      {
                        icon: () => <ClearIcon color="error" />,
                        tooltip: 'Rechazar',
                        onClick: (event, rowData) => {
                          handleOpen(true)
                          setIdNotification(rowData.IdNotification)
                        },
                      },
                    ]}
                    onSelectionChange={(selectedRows) =>
                      console.log(selectedRows)
                    }
                    options={{
                      sorting: true,
                      search: true,
                      searchFieldAlignment: 'right',
                      searchAutoFocus: true,
                      searchFieldVariant: 'standard',
                      filtering: true,
                      paging: true,
                      pageSizeOptions: [2, 5, 10, 20],
                      pageSize: 5,
                      paginationType: 'stepped',
                      showFirstLastPageButtons: false,
                      paginationPosition: 'bottom',
                      exportButton: true,
                      exportAllData: true,
                      exportFileName: 'TableData',
                      actionsColumnIndex: -1,
                      selection: false,
                      showSelectAllCheckbox: false,
                      showTextRowsSelected: false,
                      selectionProps: (rowData) => ({
                        disabled: rowData.age == null,
                      }),
                      columnsButton: true,
                      rowStyle: (data, index) =>
                        index % 2 === 0 ? { background: '#f5f5f5' } : null,
                      headerStyle: { background: '#014b96', color: '#fff' },
                    }}
                    localization={{
                      body: {
                        editRow: {
                          deleteText: '¿Está seguro de eliminar el registro?',
                        },
                      },
                      header: {
                        actions: 'Acciones',
                      },
                      toolbar: {
                        searchPlaceholder: 'Buscar',
                      },
                    }}
                    title=" "
                  />
                </Grid>
              </Grid>
            </div>
          </div>
        </Grid>
      ) : (
        <Box className="loadingEditContainer">
          <Grid className="loadingSub">
            <CircularProgress />
          </Grid>
        </Box>
      )}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modalPYME">
          <Grid className="modalTitle">
            <Typography
              id="modal-modal-title"
              style={{ fontWeight: '900' }}
              variant="h6"
              component="h2"
            >
              Notificación
            </Typography>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid
              container
              spacing={1}
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
              }}
            >
              <Grid
                container
                spacing={1}
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'flex-end',
                }}
              >
                <Grid item xs={12} sm={12} md={12}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12}>
                      <label className="responsiveLabel">Observaciones:</label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormControl fullWidth>
                        <textarea
                          id="Observation"
                          name="Observation"
                          placeholder="Observaciones"
                          customInput={TextField}
                          maxLength={500}
                          inputProps={{ maxLength: 250 }}
                          onChange={(e) => {
                            setBody({
                              ...body,
                              Observation: e.target.value,
                            })
                          }}
                          value={body.Observation}
                        ></textarea>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid className="buttonsPYME">
                <Button className="cancelButton" onClick={() => handleClose()}>
                  Cancelar
                </Button>
                <Button
                  className="confirmButton"
                  onClick={handleActualizar}
                  disabled={body.Observation === ''}
                >
                  Rechazar
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </section>
  )
}
export default TableFormularios
